import axios from "axios";
import * as actionTypes from "./actionTypes";
import { retrievedPayloads } from "../utils/retrievedPayloads";
import endPoints from "../utils/endPoints";

const setTopCollection = (payload) => ({
  type: actionTypes.SET_COLLECTION,
  payload,
});

const setTopNft = (payload) => ({
  type: actionTypes.SET_TOP_NFT,
  payload,
});

const setTopMints = (payload) => ({
  type: actionTypes.SET_TOP_MINT,
  payload,
});

const setNewCollection = (payload) => ({
  type: actionTypes.SET_NEW_COLLECTION,
  payload,
});

const setTimeFrame = (payload) => ({
  type: actionTypes.GET_TIME_FRAMES,
  payload,
});

const sortingListing = (items, field, sort, time) => {
  let sortArray = [...items];
  if (sort) {
    if (sort == "ASC") {
      if (time) {
        sortArray = sortArray.sort(
          (a, b) => new Date(a[field]) - new Date(b[field])
        ); //asc
      } else {
        sortArray = sortArray.sort((a, b) => a[field] - b[field]); //asc
      }
    } else if (sort == "DESC") {
      if (time) {
        sortArray = sortArray.sort(
          (a, b) => new Date(b[field]) - new Date(a[field])
        ); //desc
      } else {
        sortArray = sortArray.sort((a, b) => b[field] - a[field]); //desc
      }
    }
  }
  return sortArray;
};

const sortingListingString = (items, field, sort, string) => {
  let sortArray = [...items];
  if (sort) {
    if (sort == "ASC") {
      if (string) {
        sortArray = sortArray.sort((a, b) => a[field].localeCompare(b[field])); //asc
      } else {
        sortArray = sortArray.sort((a, b) => a[field] - b[field]); //asc
      }
    } else if (sort == "DESC") {
      if (string) {
        sortArray = sortArray.sort((a, b) => b[field].localeCompare(a[field])); //desc
      } else {
        sortArray = sortArray.sort((a, b) => b[field] - a[field]); //desc
      }
    }
  }
  return sortArray;
};

const headers = {
  Authorization:
    "FC4AE128B53B3E596ED8003CFC6D5FB52B61E3CA6C71C3B247BF97F8781A1FE4",
};

// Get data from endpoint
export const getPayload = (baseEndPoint, queryParams) => (dispatch) => {
  // Check to see if request was already sent
  // if (!retrievedPayloads.has(baseEndPoint)) {
  //   retrievedPayloads.set(baseEndPoint, true);

  axios
    .get(process.env.REACT_APP_REQUEST_URL + `/${baseEndPoint}`, {
      params: queryParams,
      headers: headers,
    })
    .then((response) => response.data)
    .then((data) => {
      switch (baseEndPoint) {
        case endPoints.allCollection:
          dispatch(setTopCollection(data));
          break;
        case endPoints.allNft:
          dispatch(setTopNft(data));
          break;
        case endPoints.newCollection:
          dispatch(setNewCollection(data));
          break;
        case endPoints.topMints:
          dispatch(setTopMints(data));
          break;
        case endPoints.timeFrames:
          dispatch(setTimeFrame(data));
        default:
          break;
      }
    })
    .catch((error) => {
      console.log(error);
    });
  // }
};

export const AllItemSort =
  (collectionName, items, field, sort = false, time = false) =>
    (dispatch) => {
      const sortArray = sortingListing(items, field, sort, time);
      switch (collectionName) {
        case endPoints.allCollection:
          dispatch(setTopCollection({ message: sortArray }));
          break;
        case endPoints.allNft:
          dispatch(setTopNft({ message: sortArray }));
          break;
        case endPoints.newCollection:
          dispatch(setNewCollection({ message: sortArray }));
          break;
        case endPoints.topMints:
          dispatch(setTopMints({ message: sortArray }));
          break;
        default:
          break;
      }
    };

export const getMethod =
  (baseEndPoint, queryParams = {}, URL = process.env.REACT_APP_BACKEND_URL) =>
    (disptach) => {
      return axios
        .get(URL + `/${baseEndPoint}`, {
          params: queryParams,
          headers: headers,
        })
        .then((response) => response.data)
        .then((res) => {
          return { data: res, isSuccess: true };
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    };

export const graphData = () => (dispatch) => {
  return axios
    .get(process.env.REACT_APP_BACKEND_URL + `/grossdata`, {
      headers: headers,
    })
    .then((res) => res.data.sort((a, b) => new Date(a.date) - new Date(b.date)))
    .then((res) => {
      let array = [];
      res.map((items) => {
        array.push([
          items.date,
          parseFloat(items?.price?.replace(/[£$]/g, "")) || 0,
        ]);
      });
      return array;
    });
};

export const SortItemList = (items, field, sort, time, string) => {
  if (time) {
    return sortingListing(items, field, sort, time);
  } else {
    return sortingListingString(items, field, sort, string);
  }
};

export const PostData =
  (URL, data = {}) =>
    (dispatch) => {
      return axios
        .post(process.env.REACT_APP_REQUEST_URL + `/${URL}`, data, {
          headers: headers,
        })
        .then((res) => res.data)
        .then((res) => {
          return { status: true, ...res };
        });
    };
